// src/pages/ForgotPassword.jsx
import React, { useState } from "react";
import { Link } from "react-router-dom";
import { AuthAPI } from "../api";
import { ui, uiHandlers } from "../uiStyles";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [msg, setMsg] = useState("");
  const [resetUrl, setResetUrl] = useState("");
  const [busy, setBusy] = useState(false);

  async function onSubmit(e) {
    e.preventDefault();
    setBusy(true);
    setMsg("");
    setResetUrl("");

    try {
      const data = await AuthAPI.forgotPassword(email);

      setMsg(
        data.message || "If that email exists in this workspace, a reset link has been generated."
      );

      if (data.reset_url) {
        setResetUrl(data.reset_url);
      }
    } catch (err) {
      setMsg(err.message || "Could not process request.");
    } finally {
      setBusy(false);
    }
  }

  return (
    <div style={{ ...ui.page, maxWidth: 760, paddingTop: 48 }}>
      <div style={{ ...ui.card, maxWidth: 460, margin: "40px auto 0" }}>
        <div style={{ marginBottom: 20 }}>
          <div style={{ fontSize: 22, fontWeight: 700, color: "#ffffff" }}>
            Forgot password
          </div>
          <div
            style={{
              fontSize: 13,
              color: "#9fb0c3",
              marginTop: 6,
              lineHeight: 1.5,
            }}
          >
            Enter your email and we’ll generate a password reset link for this workspace.
          </div>
        </div>

        {msg && (
          <div
            style={{
              marginBottom: 14,
              padding: "10px 12px",
              borderRadius: 10,
              border: "1px solid rgba(255,255,255,0.10)",
              background: "rgba(255,255,255,0.03)",
              color: "#dbeafe",
              fontSize: 13,
            }}
          >
            {msg}
          </div>
        )}

        <form onSubmit={onSubmit} style={{ display: "grid", gap: 14 }}>
          <input
            style={ui.input}
            {...uiHandlers.focus}
            type="email"
            placeholder="you@company.com"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
          />

          <button
            type="submit"
            disabled={busy}
            style={{
              ...ui.btnPrimary,
              width: "100%",
              opacity: busy ? 0.8 : 1,
              cursor: busy ? "not-allowed" : "pointer",
            }}
            {...(!busy ? uiHandlers.primaryHover : {})}
          >
            {busy ? "Generating…" : "Send reset link"}
          </button>
        </form>

        {resetUrl && (
          <div style={{ marginTop: 16 }}>
            <div style={{ marginBottom: 8, color: "#9fb0c3", fontSize: 12 }}>
              Local dev reset link:
            </div>
            <a href={resetUrl} style={ui.link}>
              Open reset page
            </a>
          </div>
        )}

        <div style={{ textAlign: "center", marginTop: 16 }}>
          <Link to="/login" style={ui.link}>
            Back to sign in
          </Link>
        </div>
      </div>
    </div>
  );
}
